const state = {
  type: 'wifi',
  isConnected: true,
  isInternetReachable: true,
  details: null
};

export const configure = () => {};
export const fetch = async () => state;
export const refresh = async () => state;
export const addEventListener = (listener) => {
  listener?.(state);
  return () => {};
};
export const useNetInfo = () => state;
export const useNetInfoInstance = () => ({ netInfo: state, refresh });

export default {
  configure,
  fetch,
  refresh,
  addEventListener,
  useNetInfo,
  useNetInfoInstance
};
